import React, { useState } from 'react';
import './skills.css';

const Skills = () => {
  const [activeTab, setActiveTab] = useState('webdev');

  const skillCategories = {
    webdev: {
      label: 'Web Dev & Programming',
      icon: 'bx bx-code-alt',
      skills: [
        { name: 'HTML/CSS', level: 85 },
        { name: 'JavaScript', level: 80 },
        { name: 'React', level: 80 },
        { name: 'Node.js', level: 75 },
        { name: 'TypeScript', level: 70 },
        { name: 'MongoDB', level: 75 },
        { name: 'PostgreSQL', level: 70 },
        { name: 'C++', level: 75 },
        { name: 'Docker', level: 65 },
        { name: 'Git', level: 80 },
        { name: 'Linux', level: 70 },
        { name: 'Data Structures', level: 80 },
      ],
    },
    datascience: {
      label: 'Data Analytics & ML',
      icon: 'bx bx-data',
      skills: [
        { name: 'Python', level: 85 },
        { name: 'MySQL/SQL', level: 80 },
        { name: 'NumPy/Pandas', level: 85 },
        { name: 'Matplotlib/Seaborn', level: 80 },
        { name: 'Sci-Kit Learn', level: 75 },
        { name: 'TensorFlow', level: 70 },
        { name: 'NLP', level: 65 },
        { name: 'Power BI', level: 75 },
        { name: 'Tableau', level: 70 },
        { name: 'Microsoft Excel', level: 80 },
        { name: 'Flask', level: 70 },
        { name: 'Jupyter', level: 85 },
      ],
    },
  };

  return (
    <section className="skills section" id="skills">
      <div className="container">
        <div className="section__header reveal">
          <span className="section__label">Skills</span>
          <h2 className="section__title">Tech Stack</h2>
          <p className="section__subtitle">Technologies and tools I work with</p>
        </div>

        <div className="skills__tabs reveal">
          {Object.entries(skillCategories).map(([key, category]) => (
            <button
              key={key}
              className={`skills__tab ${activeTab === key ? 'skills__tab--active' : ''}`}
              onClick={() => setActiveTab(key)}
              id={`skills-tab-${key}`}
            >
              <i className={category.icon}></i>
              <span>{category.label}</span>
            </button>
          ))}
        </div>

        <div className="skills__content reveal">
          <div className="skills__grid">
            {skillCategories[activeTab].skills.map((skill, index) => (
              <div
                className="skills__item"
                key={`${activeTab}-${skill.name}`}
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                <span className="skills__item-name">{skill.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;